import { getLanguageCode } from '../utilities';

export default class InvoiceClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/v1-api-customer-private-file-list-' + languageCode;
        this._dataResponse = 'response';
        this._dataSrc = 'customerPrivateFileList';
    }

    get uri()
    {
        return this._uri;
    }

    get dataResponse()
    {
        return this._dataResponse;
    }

    get dataSrc()
    {
        return this._dataSrc;
    }

    /**
	 * GET
	 */

    /**
	 * @returns {Promise<Response>}
	 */
    fetchAllItems()
    {
        return fetch(this._uri);
    }

    /**
	 * PUT
	 */

    /**
	 * @param {array} ids - Document IDs
	 * @returns {Promise<Response>}
	 */
    updateNoticedItems(ids)
    {
        return fetch(this._uri + '/noticed', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                ids.map(id => ({ 'customerPrivateFileId': id }))
            )
        });
    }

    /**
	 * @param {number} id - Document ID
	 * @returns {Promise<Response>}
	 */
    updateDownloadedItem(id)
    {
        return fetch(this._uri + '/downloaded', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify([
                { 'customerPrivateFileId': id }
            ])
        });
    }
}
